export default __webpack_public_path__ + "static/media/pic1.dea6846a.jpg";